import { Component, OnInit, ViewChild, NgZone, Inject,ViewChildren,ElementRef,QueryList } from '@angular/core';
import { BillingService } from '../billing.service';
import { BillingEntry } from '../billingentry';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessagerComponent } from '../../messager/messager/messager.component';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import { LoggingService } from '../../utils/logging.service';
import { AuthService } from '../../auth.service';



@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.css']
})
export class BillingComponent implements OnInit {

  allJobs: any[] = [];
  loading$: Observable<boolean>;
  isLoading : boolean = false;
  term: string;
  fromDate: Date;
  toDate: Date;
  user;
  usernamee;
  updaterFilename;
  csvselected;
  thejobs: BillingEntry[];
  jobObserver:any ;
  loadingScroll:boolean = false;
  currentPage : number = 0 ;
  isLast : boolean = false;
  firstLoad : boolean = true;
  pageNo : number = 1;
  pageSize : number = 20;

  constructor(public service: BillingService, public dialog: MatDialog, public messager: MessagerComponent, public log: LoggingService ) {
   }


   ngAfterViewInit(): void {
    this.lastJob.changes.subscribe( (res) => {
      if(res.last){
        this.jobObserver.observe(res.last.nativeElement);
      }
    })
  }

  @ViewChildren('lastJob',{read: ElementRef})
  lastJob:QueryList<ElementRef>

  ngOnInit(): void {

    this.startingfunc()
    this.intersectionObserver();
    this.toDate = new Date(this.service.getCurrentDate());
    this.loading$ = this.service.loadingD$;
  }
  startingfunc(): void{
    this.service.getTodaysJobsWithPagination(this.pageSize,this.pageNo).subscribe(res => {
      this.pageNo+=1 ;
      res.Jobs.forEach(e => {
        this.allJobs.push(e)
      });
    })
  }
  saveEntry(job): void {
    console.log(job);
    this.service.updateChanges(job).subscribe(
      () => {
        this.messager.openSnackBar('Saved Successfully!', 'Close','successAlert')
        console.log('Done.');
      },
      err => {
        this.messager.openSnackBar('Error: ' + err, 'Close', 'errorAlert')
        console.log(err);
      }
    );
    //this.service.updateChanges(job)
  }

  intersectionObserver() {

    let options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.3,
    };
    this.jobObserver = new IntersectionObserver( (observer)=> {
      this.loadingScroll = true;
        if(observer[0].isIntersecting && !this.firstLoad && !this.isLast){
          this.service.getTodaysJobsWithPagination(this.pageSize,this.pageNo).subscribe((res) => {
            if(res.Rows < this.pageSize ) this.isLast = true
            this.pageNo+=1 ;
            res.Jobs.forEach((e) => {
              this.allJobs.push(e)
            });
          })
          }else {//this.lastPageLoaded = true;
            this.loadingScroll = false;
          }
    }, options)
    this.firstLoad = false;
    this.loadingScroll = false;
  }
  filterJobs(dateFrom, dateTo): void {
    console.log('To Date: ', dateTo);
    this.allJobs=[]
    this.service.dateChange(dateFrom, dateTo).subscribe((res)=>{
      res.Jobs.forEach((e) => {
        this.allJobs.push(e)})
    },)
  }

  cs(): void {
    //alert('Coming Soon');
    alert('Sorry... this is currently broken! To use this function, please login to Raterhelper Version 2. Will be working starting 08/18.')

    //document.getElementById('importedCSV').click()

  }

  parseCSV(event) : void {


      console.log(event.target.files[0]);

      const file:File = event.target.files[0];

      var reader = new FileReader();
      let content;
      var extension = file.name.split('.')[1];
      this.updaterFilename = file.name;

      console.log(this.csvselected);

      if (extension != "csv" ){
        this.messager.openSnackBar('Invalid file type: ' + extension, '', 'errorAlert');
        return;
      }

      let service = this.service;
      let messager = this.messager;
      let log = this.log;
      let un = this.usernamee;

      reader.onload = function(){

        content = reader.result;
        //console.log($scope.filecontent);
        console.log(content);


        var postJSON = {
          file : content
        }

            service.parseCSV(postJSON).subscribe(
              (res) => {
                if(res.Error){
                  log.error(un + 'attempted to use csv importer for billing and encountered an error.');
                  messager.openSnackBar('Import failed...', '[close]', 'errorAlert');
                }else{
                  log.info(un + ' successfully updated billing via the csv updater with ' + res.RowsUpdated + 'rows.');
                  messager.openSnackBar( res.RowsUpdated + ' rows updated!', '[close]', 'successAlert');
                  console.log(res);
                }
              }, err => {
                log.error(un + ' encountered an error using the csv updater: ' + err.toString());
                messager.openSnackBar('Err: ' + err, '[close]', 'errorAlert');
                console.log(err);
              }
            )

      }


      //reader.onload = this.onloadFunction(reader, content,this.cd);

      reader.readAsText(file);

 }


  cardClass(index): string {
    return index %2 == 0 ? 'container-lite' : 'container-shaded';
  }

  getColor(ponumber): string {
    return ponumber.length > 0 ? 'row_green' : 'row';
  }

  statusClass(index, status): string {
    let lstatus = status.toLowerCase();
    if (lstatus.includes('fail') || lstatus.includes('cancel')){
      return 'status_fail';
    }else if (lstatus.includes('complete') || lstatus.includes('pass')){
      return 'status_pass';
    }
  }

  getPlanInfo(job): void {
    console.log(job);
    this.service.getPlanInfo(job).subscribe(
      res => {
        console.log(res);
        const dialogRef = this.dialog.open(PlanModalComponent, {
          minWidth: '40vw',
          height: '50vh',
          data: {
            info : res.Info,
            job : job
          }
        });


      }, err => {
        console.log(err);
      }
    )
  }





}

@Component({
  template: `
  <h1 mat-dialog-title style="text-align:center;">Plan Info for {{data.job.street_address}} ({{data.job.subdivision_name}}-{{data.job.lot}} )</h1>
  <div>
    <div>
      <p style="text-align: center;
    font-size: 20px;"> Square Footage: {{this.squarefootage > 0 ? this.squarefootage : 'Plan data not yet assigned'}}</p>
    </div>
    <div>
      <p style="text-align: center;
    font-size: 20px;"> Total Area: {{this.numberOfSystems > 0 ? this.numberOfSystems : 'Plan data not yet assigned'}} </p>
    </div>
  </div>


  <div style="position: relative;
    margin-top: 10px;
    top: 20px;
    /* left: 42px; */
    width: 70%;
    /* background: white;">
    <button mat-button (click)="dref.close()"  style="position: relative;
    left: 50%;
    background: #ffffff;
    border-radius: 5px;
    font-size: 24px;">Close</button>
  </div>

`
})

export class PlanModalComponent implements OnInit {

  numberOfSystems = 0;
  squarefootage = 0;

  constructor(public dref: MatDialogRef<PlanModalComponent>, private messager: MessagerComponent, @Inject(MAT_DIALOG_DATA) public data: any, public log: LoggingService){}

  ngOnInit() : void {
    if(this.data.info.hvac_2_area != null){
      this.numberOfSystems = 2;
    }

    if(this.data.info.hvac_3_area != null){
      this.numberOfSystems = 3;
    }

    if(this.data.info.hvac_4_area != null){
      this.numberOfSystems = 4;
    }


    this.squarefootage = parseFloat(this.data.info.hvac_1_area) +  parseFloat(this.data.info.hvac_2_area) +  parseFloat(this.data.info.hvac_3_area) + parseFloat(this.data.info.hvac_4_area);
    console.log(this.data);
    console.log(this.squarefootage);
    console.log(this.numberOfSystems);

  }



}
